export const ThinSortIcon = ({
  size = 18,
  strokeColor = "#666666",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox="0 0 24 24"
    fill="none"
    {...props}
  >
    <path
      d="M12 21L16.5 14.5H7.5L12 21ZM12 3L16.5 9.5H7.5L12 3Z"
      stroke={strokeColor}
      stroke-width="2"
      stroke-linejoin="round"
    />
  </svg>
);
